import { render, staticRenderFns } from "./XCookiesSetting.vue?vue&type=template&id=326b3d78&scoped=true&"
import script from "./XCookiesSetting.vue?vue&type=script&lang=js&"
export * from "./XCookiesSetting.vue?vue&type=script&lang=js&"
import style0 from "./XCookiesSetting.vue?vue&type=style&index=0&id=326b3d78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326b3d78",
  null
  
)

export default component.exports